import { Fragment, useEffect, useState } from 'react';
import './SubscriptionsList.css';
import SubscriptionDetailsDialog from './subscriptionDetailsDialog/SubscriptionDetailsDialog';
import { DeleteSubscription } from '../../../Services';
import { toast } from 'react-toastify';

const SubscriptionsList = ({ allSubscriptions, onSubmit, onListRefresh }) => {
	const [ subscriptions, setSubscriptions ] = useState([]);
	const [ showDialog, setShowDialog ] = useState(false);
	const [ editedSubscriptionId, setEditedSubscriptionId ] = useState(null);

	useEffect(() => {
		if (allSubscriptions && allSubscriptions.length > 0) {
			setSubscriptions(allSubscriptions);
		}
	}, []);

	const handleToggleDialog = async (e, id) => {
		if (e) e.preventDefault();

		setShowDialog(!showDialog);

		if (!showDialog) {
			if (id !== undefined) {
				//edit
				setEditedSubscriptionId(id);
			} else {
				//new
				setEditedSubscriptionId(null);
			}
		} else {
			setEditedSubscriptionId(null);
		}
	};

	const handleOnSubscriptionSubmit = async () => {
		if (onSubmit) {
			onSubmit();
		}

		handleToggleDialog();
	};

	const handleDeleteSubscription = async (e, id) => {
		e.preventDefault();

		if (window.confirm('Are you sure that you want to delete subscription?')) {
			let response = await DeleteSubscription(id);

			if (response) {
				toast.success('Subscription successfully deleted');

				if (onListRefresh) {
					onListRefresh();
				}
			}
		}
	};

	return (
		<Fragment>
			<Fragment>
				<div className="new-subscription-wrapper">
					<button className="btn btn-primary" onClick={(e) => handleToggleDialog(e, null)}>
						Add New Subscription
					</button>
				</div>
				<table className="subscriptions-list items-list table table-responsive">
					<thead>
						<tr>
							<th className="number" scope="col">
								#
							</th>
							<th scope="col">Name</th>
							<th scope="col">Description</th>
							<th className="count" scope="col">
								Amount
							</th>
							{/* <th className="count" scope="col">
								Discount
							</th>
							<th className="count" scope="col">
								Trial Days
							</th>
							<th className="count" scope="col">
								Tags
							</th> */}
							<th className="subscription-action" scope="col" />
						</tr>
					</thead>
					<tbody>
						{subscriptions &&
							subscriptions.length > 0 &&
							subscriptions.map((subscription, index) => (
								<tr key={subscription.id}>
									<th className="number" scope="row">
										{index + 1}
									</th>
									<td className="name text-truncate">{subscription.name}</td>
									<td>{subscription.description}</td>
									<td className="count">{`$${subscription.amount}`}</td>
									{/* <td className="count">{subscription.discount}</td>
									<td className="count">{subscription.trialDays}</td>
									<td className="count">{subscription.tags}</td> */}
									<td className="subscription-action text-end">
										<button
											className="btn btn-link py-0"
											onClick={(e) => handleToggleDialog(e, subscription.id)}
											title="Edit Subscription Details"
										>
											<i className="fa-solid fa-pen" />
										</button>
										<button
											className="btn btn-link py-0"
											onClick={(e) => handleDeleteSubscription(e, subscription.id)}
											title="Delete Subscription"
										>
											<i className="fa-solid fa-trash-can" />
										</button>
									</td>
								</tr>
							))}
					</tbody>
				</table>
			</Fragment>

			{showDialog && (
				<SubscriptionDetailsDialog
					subscriptionId={editedSubscriptionId}
					onSubmit={handleOnSubscriptionSubmit}
					onClose={handleToggleDialog}
				/>
			)}
		</Fragment>
	);
};

export default SubscriptionsList;
